import React, { FC } from 'react'

import styles from './styles.module.css'

type Props = {
  icon: string
  label: string
  count: number
  total: number
  onPicked: (value: number) => void
  className?: string
}

export const LockerSizePicking: FC<Props> = ({
  icon,
  label,
  count,
  total,
  onPicked,
  className,
}) => {
  return (
    <div className={[styles.container, className].filter(Boolean).join(' ')}>
      <div className={styles.label}>
        <img src={icon} alt="" />
        <p>{label}</p>
      </div>
      <div className={styles.picker}>
        <button onClick={() => onPicked(count - 1)} disabled={!count}>
          <img src="/stepper_decrement_icon.svg" alt="" width={12} height={3} />
        </button>
        <p>{count}</p>
        <button onClick={() => onPicked(count + 1)} disabled={count >= total || count === 99}>
          <img src="/stepper_increment_icon.svg" alt="" width={12} height={12} />
        </button>
      </div>
    </div>
  )
}
